import script from "./InputField.vue?vue&type=script&lang=ts&setup=true"
export * from "./InputField.vue?vue&type=script&lang=ts&setup=true"

import "./InputField.vue?vue&type=style&index=0&id=4b890e7e&lang=postcss"

const __exports__ = script;

export default __exports__